import styled from 'styled-components'
import { getUnstyledButton } from '../Semantic/Semantic.styles'
import { getTypographyIntent } from '../Typography'
import { borderRadius } from '../_styles/borderRadius'
import { colors } from '../_styles/colors'
import { getGapOutlineFocus } from '../_styles/mixins'
import { getShadow } from '../_styles/shadows'
import { spacing } from '../_styles/spacing'

export const StyledTooltip = styled.span`
  ${getTypographyIntent('small')}
  color: ${colors.white};
  max-width: 200px;
  padding: ${spacing.sm}px ${spacing.md}px;
  position: relative;

  // for IE11, use word-wrap property
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;

  &:empty {
    display: none;
  }
`

export const StyledContainer = styled.span`
  display: inline-flex;
  background-color: ${colors.gray15};
  border-radius: ${borderRadius.md}px;
  ${getShadow(3, 'bottom')}

  & + [data-overlay-arrow] {
    background: ${colors.gray15};
  }

  &:has(> span:empty) + [data-overlay-arrow] {
    display: none;
  }
`

// This is for the inline typography icon button. Note: not `Button` styles
export const StyledTooltipButton = styled.button`
  ${getUnstyledButton}
  // Create a circle around the icon for focus outline
  border-radius: 50%;
  color: ${colors.gray45};
  display: inline-flex;
  vertical-align: middle;

  &:focus-visible {
    // Icon does not touch viewBox borders. Already has 1px gap
    ${getGapOutlineFocus('ontop')}
  }

  // if there is a sibling before, then add a leading space.
  // can make the Tooltip a single child to opt-out
  * + & {
    margin-left: ${spacing.sm}px;
  }
`
